<template>
    <div class="view-container">
        <modal :showDialog="activeModal === 'ADD'" @close="closeModal" :title="$t('AddScheduledReport').toUpperCase()">
            <scheduled-report-modal :current="null" @cancel="closeModal" @saved="closeModal('getData')"/>
        </modal>
        <modal :showDialog="activeModal === 'EDIT'" @close="closeModal" :title="$t('EditScheduledReport').toUpperCase()">
            <scheduled-report-modal :current="activeReport" @cancel="closeModal" @saved="closeModal('getData')"/>
        </modal>
        <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="$t('DeleteScheduledReport').toUpperCase()">
            <delete-confirm @cancel="closeModal" @confirm="deleteReportConfirm" :text="actionText"></delete-confirm>
        </modal>
        <div>
            <div class="max-grid">
                <ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :toolbarClick='toolbarClick'
                          :allowTextWrap="true" :textWrapSettings='wrapSettings'
                          :dataSource="reports" :allowPaging="true" :pageSettings='pageSettings'
                          :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true'
                          :showBusyIndicator="true">
                    <e-columns>
                        <e-column field='name' :headerText="$t('ReportName')" textAlign='Left' :customAttributes="customAttributes" width="200px" clipMode="EllipsisWithTooltip"></e-column>
                        <e-column field='frequencyName' :headerText="$t('Frequency')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox" width="110px"></e-column>
                        <e-column field='scheduleName' :headerText="$t('SendTime')" textAlign='Left' :customAttributes="customAttributes" width="180px" clipMode="EllipsisWithTooltip"></e-column>
                        <e-column field='recipientsName' :headerText="$t('Recipients')" textAlign='Left' :customAttributes="customAttributes" width="210px" :template="recipientsTemplate"></e-column>
                        <e-column field='scopeName' :headerText="$t('ReportScope')" textAlign='Left' :customAttributes="customAttributes" width="230px" :template="scopeTemplate"></e-column>
                        <e-column field='languageName' :headerText="$t('ReportLanguage')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox" width="120px"></e-column>
                        <e-column field='lastSentAt' :headerText="$t('LastSent')" textAlign='Left' type="date" :format="dateTimeFormatOptions" :customAttributes="customAttributes" width="150px"></e-column>
                        <e-column field='nextRunAt' :headerText="$t('NextRun')" textAlign='Left' type="date" :format="dateTimeFormatOptions" :customAttributes="customAttributes" width="150px"></e-column>
                        <e-column field='activeName' :headerText="$t('Active')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox" width="100px"></e-column>
                        <e-column field='id' headerText="" width="100px" :allowSorting="false" :allowFiltering="false" :template="optionsTemplate"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import { getScheduledReports, deleteScheduledReport } from '@api'
import { Sort, Page, Filter, Toolbar, Search } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue';
import Modal from '@/components/Modal.vue'
import DeleteConfirm from '@/components/DeleteConfirm.vue'
import ScheduledReportModal from '@/components/ScheduledReports/ScheduledReportModal.vue'
import ReportListCell from '@/components/ScheduledReports/ReportListCell.vue'

export let context = null

// Musi odpowiadac ReportFrequencyEnum i SupportedLanguageEnum na backendzie.
const FREQUENCY_LABELS = ['Daily', 'Weekly', 'Monthly'];
const LANGUAGE_LABELS = ['English', 'Norwegian'];
const WEEK_DAY_LABELS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export default {
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search ]
    },
    components: {
        Modal,
        DeleteConfirm,
        ScheduledReportModal
    },
    data() {
        return {
            reports: [],
            activeModal: 'NONE',
            activeReport: null,
            actionText: '',

            pageSettings: { pageSize: 50, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('ScheduledReports'), align: 'Left', id: 'table-title' },
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' },
                { text: this.$t('AddScheduledReport'), prefixIcon: 'e-add', id: 'add-scheduled-report', align: 'Right' },
                'Search'
            ],
            wrapSettings: { wrapMode: 'Header' },
            filterOptions: { type: 'Menu' },
            filterCheckBox: { type: 'CheckBox' },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm', type: 'dateTime' },
            customAttributes: { class: 'customcss' },
            recipientsTemplate: function() {
                return {
                    template: {
                        extends: ReportListCell,
                        propsData: { listField: 'recipientsList' }
                    }
                }
            },
            scopeTemplate: function() {
                return {
                    template: {
                        extends: ReportListCell,
                        propsData: { listField: 'scopeList' }
                    }
                }
            },
            optionsTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div class="horizontal grow">
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('EDIT')" content="${context.$t('Edit')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>
                                </div>
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('DELETE')" content="${context.$t('Delete')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                            </div>
                        `,
                        data: function() {
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch (mode) {
                                    case 'EDIT':
                                        context.openModal(this.data, 'EDIT')
                                        break;
                                    case 'DELETE':
                                        context.openDeleteModal(this.data)
                                        break;
                                }
                            }
                        }
                    })
                }
            }
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            try {
                var result = await getScheduledReports();
                this.reports = result.map(report => {
                    var recipients = this.listRecipients(report);
                    var scopes = this.listScope(report);

                    return Object.assign({}, report, {
                        frequencyName: this.$t(FREQUENCY_LABELS[report.frequency] || '-'),
                        languageName: LANGUAGE_LABELS[report.language] || '-',
                        scheduleName: this.formatSchedule(report),
                        recipientsList: recipients,
                        // Pelny tekst zostaje w polu kolumny, zeby sortowanie, filtrowanie i wyszukiwanie widzialy wszystkie pozycje.
                        recipientsName: recipients.join(', '),
                        scopeList: scopes,
                        scopeName: scopes.join(', '),
                        activeName: report.isActive ? this.$t('Yes') : this.$t('No'),
                        lastSentAt: report.lastSentAt ? new Date(report.lastSentAt) : null,
                        nextRunAt: report.nextRunAt ? new Date(report.nextRunAt) : null
                    });
                });
            } finally {
                this.$store.dispatch('set_loading', false)
            }
        },
        pad(value) {
            return value < 10 ? `0${value}` : `${value}`;
        },
        formatSchedule(report) {
            var time = `${this.pad(report.sendHour)}:${this.pad(report.sendMinute)}`;
            var suffix = report.skipWeekends ? ` (${this.$t('WithoutWeekends')})` : '';

            if (report.frequency === 1 && report.dayOfWeek) {
                return `${this.$t(WEEK_DAY_LABELS[report.dayOfWeek - 1])}, ${time}${suffix}`;
            }

            if (report.frequency === 2 && report.dayOfMonth) {
                return `${this.$t('DayOfMonth')} ${report.dayOfMonth}, ${time}${suffix}`;
            }

            return `${time}${suffix}`;
        },
        listRecipients(report) {
            var recipients = report.recipients || [];
            return recipients.map(x => x.name || x.userEmail || x.email).filter(x => x);
        },
        listScope(report) {
            var scopes = report.scopes || [];
            var systems = scopes.filter(x => x.systemId).map(x => x.systemName).filter(x => x);
            var groups = scopes.filter(x => x.systemGroupId).map(x => `${x.systemGroupName} (${this.$t('Group')})`).filter(x => x);

            return systems.concat(groups);
        },
        toolbarClick: function(args) {
            switch (args.item.id) {
                case 'add-scheduled-report':
                    this.openModal(null, 'ADD')
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        openModal(item, mode) {
            this.activeReport = item
            this.activeModal = mode
        },
        openDeleteModal(item) {
            this.activeReport = item
            this.actionText = `${this.$t('DeleteScheduledReport')}: ${item.name}`
            this.activeModal = 'DELETE'
        },
        closeModal(mode) {
            this.activeReport = null;
            this.actionText = '';
            this.activeModal = 'NONE';

            if (mode === 'getData') {
                this.getData()
            }
        },
        async deleteReportConfirm() {
            await deleteScheduledReport(this.activeReport.id);
            this.closeModal('getData')
        }
    },
    mounted: async function() {
        context = this

        await this.getData();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/ScheduledReports.vue